import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const user = function(userId, password) {
    return apiService.post('authenticate/user', {
        userId,
        password
    });
}

const invite = function(inviteId) {
    return apiService.post('authenticate/invite', {inviteId});
}

const token = function(token) {
    return apiService.post('authenticate/token', {token});
}

export default {
    user,
    invite,
    token
}